let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bVl1P")).then(() => parcelRequire('hnY2b'));